import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsString } from '@pit/core';
import { IDtoResourceAttribute } from '../interfaces/dto.resource.attribute.interface';
import { IDtoMandator } from '../interfaces/dto.mandator.interface';
import { DtoMandator } from './dto.mandator';

// @dynamic
@JsonObject('DtoResourceAttribute')
export class DtoResourceAttribute extends ModelEntity implements IDtoResourceAttribute {

    constructor(initValues: Partial<IDtoResourceAttribute> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('attributeType', String, true)
    public attributeType?: string = null;

    @JsonProperty('attributeKey', String, true)
    public attributeKey?: string = null;

    @JsonProperty('attributeValue', String, true)
    public attributeValue?: string = null;

    @JsonProperty('mandator', DtoMandator, true)
    public mandator?: IDtoMandator = null;

}
